import { jsx as _jsx } from "react/jsx-runtime";
import { Modal, Result } from "antd";
import { useMemo } from "react";
import ReactRouterPrompt from "react-router-prompt";
import { useI18n } from "../../contexts/i18n.js";
const Prompt = ({ when, title })=>{
    const { __ } = useI18n();
    const [useTitle, useSubtitle = ""] = useMemo(()=>title.split(".").map((s)=>`${s.trim()}.`), [
        title
    ]);
    return /*#__PURE__*/ _jsx(ReactRouterPrompt, {
        when: when,
        children: ({ isActive, onConfirm, onCancel })=>/*#__PURE__*/ _jsx(Modal, {
                open: isActive,
                onCancel: onCancel,
                onOk: onConfirm,
                centered: true,
                okText: __("Leave"),
                cancelText: __("Cancel"),
                children: /*#__PURE__*/ _jsx(Result, {
                    status: "warning",
                    title: useTitle,
                    subTitle: useSubtitle
                })
            })
    });
};
export { Prompt };
